module.exports = __webpack_public_path__ + "static/img/dylogo.492f347.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dylogo.png
// module id = 4jH8
// module chunks = 25